/** API documentation: https://devcl.rwave.eu/docs/ */
import {Environment} from '../config/client-config.token';

const BASE_URL = 'https://devcl.rwave.eu';
const BASE_API = `${BASE_URL}/api/`;
const BASE_WS = 'wss://devcl.rwave.eu/';
const IMAGE_URL = 'https://devcl.rwave.eu';
const LINK_URL = `${IMAGE_URL}/`;

export const environment: Environment = {
  production: false,
  enableSentry: false,
  sentryEnvironment: 'Development',

  defaultConfig: {
    clientId: 'local-dev',
    clientName: 'Local Development',
    baseUrl: BASE_URL,
    baseApiUrl: BASE_API,
    baseWsUrl: BASE_WS,
    imageUrl: IMAGE_URL,
    linkUrl: LINK_URL,
  }
};
